import { Component, OnInit, Input } from '@angular/core';
import { IMAGE_BASE__URL } from '../../core/services/CusHttp';
import { Router } from '@angular/router';

@Component( {
  selector: 'course-hot-detail',
  templateUrl: './course-hot-detail.component.html',
  styleUrls: [ './course-hot-detail.component.scss' ]
} )
export class CourseHotDetailComponent implements OnInit {
  @Input() couInfoData: any = [];
  IMAGE_BASE__URL = IMAGE_BASE__URL;
  constructor(
    private _router: Router
  ) { }

  ngOnInit() {
  }


  //跳转详情
  gotoDetail( id: any ) {
    this._router.navigate(['/station/coudetail', id]);

  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/course-hot-detail/course-hot-detail.component.ts